export default "__VITE_ASSET__c255347a__"